import { useContext } from "react";
import { styled } from "@mui/material/styles";
import ListItem from "@mui/material/ListItem";
import MuiRadioGroup from "@mui/material/RadioGroup";
import MuiFormControlLabel from "@mui/material/FormControlLabel";
import MuiFormControl from "@mui/material/FormControl";
import MuiFormLabel from "@mui/material/FormLabel";
import RadioInput from "../RadioInput";
import { THEME_COLORS } from "constants/theme";
import { ComponentPropsContext } from "layouts/Flow Designer/context";

const RadioGroup = styled(MuiRadioGroup)(() => ({
  // paddingLeft: 8,
}));

const FormControl = styled(MuiFormControl)(() => ({
  width: "100%",
  marginTop: 8,
}));

const FormControlLabel = styled(MuiFormControlLabel)(() => ({
  fontSize: "12px !important",
  marginTop: 8,

  "&:first-of-type": {
    marginRight: 40,
    marginLeft: 0,
  },
  "& .MuiButtonBase-root": {
    marginTop: 0,
    marginRight: 8,
  },
}));

const FormLabel = styled(MuiFormLabel)(({ theme }) => ({
  fontSize: "12px !important",
  marginBottom: "16px",
  "&.Mui-focused": {
    color: THEME_COLORS[theme.palette.mode.toUpperCase()].PRIMARY_FONT,
  },
}));

const RadioGroupListItem = ({ action, isHorizontal, allowEditWorkflow }) => {
  const { actionForm } = useContext(ComponentPropsContext);

  return (
    <ListItem key={action.field}>
      <FormControl>
        <FormLabel id="component-radio-buttons-group-label">{action.label}</FormLabel>
        <RadioGroup
          row={isHorizontal}
          aria-labelledby="component-radio-buttons-group-label"
          defaultValue={actionForm[action.field]?.value || action.value}
          name="radio-buttons-group"
        >
          {action.options.map((option) => (
            <FormControlLabel
              key={option.value}
              disableTypography
              value={option.value}
              control={
                <RadioInput
                  key={option.value}
                  name={action.field}
                  allowEditWorkflow={allowEditWorkflow}
                />
              }
              label={option.label}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </ListItem>
  );
};

export default RadioGroupListItem;
